import { Check } from "lucide-react";

export function ProgressSteps({ steps, current }) {
  const pct = Math.round(((current - 1) / (steps.length - 1)) * 100);
  return (
    <div data-testid="wizard-progress-bar" className="space-y-3">
      <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-[0.18em]">
        <span className="text-[#C59B27]" data-testid="wizard-step-indicator">Step {Math.min(current, steps.length)} of {steps.length}</span>
        <span className="text-[#7A0016]" data-testid="wizard-progress-percent">{pct}% complete</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-[#F4EFEA]">
        <div className="h-full rounded-full bg-gradient-to-r from-[#C59B27] to-[#7A0016] transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      <ol className="hidden justify-between gap-1 md:flex">
        {steps.map((s, i) => {
          const n = i + 1;
          const done = n < current;
          const active = n === current;
          return (
            <li key={s} className="flex flex-1 flex-col items-center gap-1.5 text-center">
              <span className={`flex h-7 w-7 items-center justify-center rounded-full border-2 text-xs font-bold transition-colors ${done ? "border-[#D4AF37] bg-[#D4AF37] text-white" : active ? "border-[#7A0016] bg-[#7A0016] text-[#F5E6BA]" : "border-[#D4AF37]/40 bg-white text-[#8C6A6C]"}`}>
                {done ? <Check className="h-3.5 w-3.5" /> : n}
              </span>
              <span className={`text-[11px] leading-tight ${active ? "font-semibold text-[#7A0016]" : "text-[#8C6A6C]"}`}>{s}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
